import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ErrorHandler, NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { ReactiveFormsModule } from "@angular/forms";
import { AuthInterceptor } from "./interceptor/auth-interceptor";
import { ToastyConfig, ToastyService } from "ng2-toasty";
import { NavigationItem } from "./admin/navigation/navigation";
import { SkyaccessApp } from "./services/skyaccessconfig/skyaccess-app.service";
import { LocalizationHandlerService } from "./services/admin/localization/localization-handler.service";
import { UrlSerializer } from "@angular/router";
import { LowerCaseUrlSerializer } from "./shared/serializer/url-serializer";
import { DefaultService } from "./services/admin/dashboard/default.service";
import { HandleDataService } from "./services/authentication/handle-data.service";
import { SnackBarService } from "./services/snack-bar/snack-bar.service";
import { LanguagePickerModule } from "./shared/components/language-picker/language-picker.module";
import { SharedModule } from "./shared/shared.module";
import { AdminComponent } from "./admin/admin.component";
import { NavigationComponent } from "./admin/navigation/navigation.component";
import { NavLogoComponent } from "./admin/navigation/nav-logo/nav-logo.component";
import { NavContentComponent } from "./admin/navigation/nav-content/nav-content.component";
import { NavGroupComponent } from "./admin/navigation/nav-content/nav-group/nav-group.component";
import { NavCollapseComponent } from "./admin/navigation/nav-content/nav-collapse/nav-collapse.component";
import { NavItemComponent } from "./admin/navigation/nav-content/nav-item/nav-item.component";
import { ToggleFullScreenDirective } from "./shared/full-screen/toggle-full-screen";
import { NavBarComponent } from "./admin/nav-bar/nav-bar.component";
import { NavLeftComponent } from "./admin/nav-bar/nav-left/nav-left.component";
import { NavSearchComponent } from "./admin/nav-bar/nav-left/nav-search/nav-search.component";
import { NavRightComponent } from "./admin/nav-bar/nav-right/nav-right.component";
import { CookieModalComponent } from "./shared/cookie-modal/cookie-modal.component";
import { ChatUserListComponent } from "./admin/nav-bar/nav-right/chat-user-list/chat-user-list.component";
import { ChatMsgComponent } from "./admin/nav-bar/nav-right/chat-msg/chat-msg.component";
import { ConfigurationComponent } from "./admin/configuration/configuration.component";
import {
  NgbButtonsModule,
  NgbDropdownModule,
  NgbTabsetModule,
  NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";
import { FriendComponent } from "./admin/nav-bar/nav-right/chat-user-list/friend/friend.component";
import { ColorPickerModule } from "ngx-color-picker";
import { LoadersModule } from "./loaders/loaders.module";
import { CookieModalModule } from "./shared/cookie-modal/cookie.module";
import { PwaService } from "./services/Service-worker-service";
import { DatePipe } from "@angular/common";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  declarations: [
    AppComponent,
    CookieModalComponent,
    AdminComponent,
    NavigationComponent,
    NavLogoComponent,
    NavContentComponent,
    NavGroupComponent,
    NavCollapseComponent,
    NavItemComponent,
    NavBarComponent,
    ToggleFullScreenDirective,
    NavLeftComponent,
    NavSearchComponent,
    NavRightComponent,
    ChatUserListComponent,
    ChatMsgComponent,
    ConfigurationComponent,
    FriendComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    LanguagePickerModule,
    SharedModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbButtonsModule,
    NgbTabsetModule,
    ColorPickerModule,
    LoadersModule,
    CookieModalModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    SkyaccessApp,
    NavigationItem,
    PwaService,
    ToastyService,
    ToastyConfig,
    HandleDataService,
    SnackBarService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    LocalizationHandlerService,
    DefaultService,
    {
      provide: UrlSerializer,
      useClass: LowerCaseUrlSerializer,
    },
    DatePipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
